// extracted by mini-css-extract-plugin
module.exports = {"dynamic-button__back-btn":"DynamicButtonBack_dynamic-button__back-btn__s_8UW"};